import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './config/i18n/i18n';
import React from 'react';
import {createMuiTheme, MuiThemeProvider, StylesProvider, createGenerateClassName} from "@material-ui/core";
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store/store';
import {Provider} from 'react-redux';
import {ErrorBoundary} from "react-error-boundary";
import ErrorFallback from "./components/Common/ErrorFallback/ErrorFallback";
import themeData from './resources/theme/theme';
import DevToolsConnected from "./components/DevTools/DevToolsConnected";

const theme = createMuiTheme(themeData);

ReactDOM.render(
    <StylesProvider generateClassName={createGenerateClassName({seed: 'app-search-widget-v4'})}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <MuiThemeProvider theme={theme}>
                <Provider store={store}>
                    <App/>
                    <DevToolsConnected/>
                </Provider>
            </MuiThemeProvider>
        </ErrorBoundary>
    </StylesProvider>,
    document.getElementById('app-search-widget')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
